import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { FaUndo } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import { AiFillCloseCircle, AiFillLike } from "react-icons/ai";
import { IoExitOutline } from "react-icons/io5";
import { HiBadgeCheck } from "react-icons/hi";
import axios from "axios";
import { API_HOST } from "../api_utils";
import { toast } from "react-toastify";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import {
  Autocomplete,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { Box, Divider, Modal } from "@material-ui/core";
import { TbArrowBackUp } from "react-icons/tb";
import { RiSave2Fill } from "react-icons/ri";

function StartofDay(props) {
  let navigate = useNavigate();
  const { userDataFromStorage, coloredTheme } = props;
  const [loading, setLoading] = useState(false);
  const [loanHeaderList, setLoanHeaderList] = useState([]);
  const [userCustomerLoan, setUserCustomerLoan] = useState([]);
  const [loanHeaderCheck, setLoanHeaderCheck] = useState("");
  const [rowData, setRowData] = useState([]);
  const [startCashAddSuccess, setStartCashAddSuccess] = useState(false);
  const [rowsWithValues, setRowsWithValues] = useState([]);

  // states for filter:
  const [filterData, setFilterData] = useState([]);
  const [agentLastName, setAgentLastName] = useState("");
  const [lastTransaction, setLastTransaction] = useState("");
  const [nextPaymentDue, setNextPaymentDue] = useState("");
  const [nextRequiredPayment, setNextRequiredPayment] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState("");
  const [totalPayment, setTotalPayment] = useState(0);
  const [agentNameList, setAgentNameList] = useState([]);
  const [totalPayments, setTotalPayments] = useState(0);
  const [paymentDoneHeaders, setPaymentDoneHeaders] = useState([]);
  const [currentTempNewPayments, setCurrentTempNewPayments] = useState(0);
  const [enterNewPaymentLoading, setEnterNewPaymentLoading] = useState(false);
  const [agentNameForApi, setAgentNameForApi] = useState("");
  const [selectedAgentName, setSelectedAgentName] = useState("");
  const searchFilterOptionsShow = useRef(true);

  const [processAllClicked, setProcessAllClicked] = useState(false);

  function compareNicknames(a, b) {
    const nicknameA = a.customer_nickname.toUpperCase();
    const nicknameB = b.customer_nickname.toUpperCase();

    if (nicknameA < nicknameB) {
      return -1;
    }
    if (nicknameA > nicknameB) {
      return 1;
    }
    return 0;
  }

  const getStartOfDay = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/loan_header/get_start_of_day?page=${currentPage}&pageSize=${pageSize}`;

    const queryParams = [];
    if (agentNameForApi) {
      queryParams.push(`agent=${agentNameForApi}`);
    }
    if (lastTransaction) {
      queryParams.push(`last_transaction_date=${lastTransaction}`);
    }

    if (nextPaymentDue) {
      queryParams.push(`next_payment_date=${nextPaymentDue}`);
    }

    if (queryParams.length > 0) {
      const queryString = queryParams.join("&");
      apiUrl += `&${queryString}`;
    }

    const { data } = await axios.get(apiUrl, config);
    if (data) {
      if (data.message) {
        setLoading(false);
      } else {
        setLoading(false);
        setUserCustomerLoan(data.sort(compareNicknames));
        setFilterData(data.sort(compareNicknames));

        const today = new Date().toDateString();
        const sumOfTempNewPayment = data.reduce((sum, item) => {
          if (
            item.last_transaction &&
            new Date(item.last_transaction).toDateString() === today &&
            item.temp_new_payment !== undefined &&
            item.temp_new_payment !== null
          ) {
            return sum + parseFloat(item.temp_new_payment);
          }
          return sum;
        }, 0);

        console.log("sumOfTempNewPayment:::::", sumOfTempNewPayment);
        setCurrentTempNewPayments(sumOfTempNewPayment);
      }
    } else {
      setLoading(false);
    }
  };

  const getAllAgentNames = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/agent_name_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setLoading(false);
      setAgentNameList(data);
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllAgentNames();
  }, [startCashAddSuccess, currentPage]);

  useEffect(() => {
    getStartOfDay();

    return () => {
      setStartCashAddSuccess(false);
    };
  }, [
    startCashAddSuccess,
    currentPage,
    agentNameForApi,
    lastTransaction,
    nextPaymentDue,
  ]);

  // useEffect(() => {
  //   const updatedRowHasValues = rowData.map(
  //     (row) => row.temp_new_payment !== ""
  //   );
  //   setRowsWithValues(updatedRowHasValues);
  // }, [rowData]);

  const handleLoanClose = (index) => {
    const payload = rowData[index];
    const loanHeaderRef = loanHeaderList[index]._id;
    // make API call with payload
  };

  const handleAddStartOfDayCall = async (index) => {
    if (rowData[index].temp_new_payment) {
      setEnterNewPaymentLoading(true);
      if (Number(rowData[index].temp_new_payment) > 0) {
        console.log("rowData[index]::::", rowData[index]);
        setLoading(true);

        const startCashPayload = {
          temp_new_payment: Number(rowData[index].temp_new_payment),
          loan_header_id: index,
        };

        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userDataFromStorage.token}`,
          },
        };
        const { data } = await axios.post(
          `${API_HOST}/api/loan_header/add_start_of_day`,
          startCashPayload,
          config
        );
        if (data) {
          if (data.message) {
            // setLoading(false);
            setEnterNewPaymentLoading(false);
            toast.error(data.message);
          } else {
            // setLoading(false);
            setEnterNewPaymentLoading(false);
            toast.success("Start Day Cash Added Successfully !!!");
            setStartCashAddSuccess(true);

            setRowData((prevState) => {
              const updatedState = { ...prevState };
              delete updatedState[index];
              return updatedState;
            });

            setTotalPayments(
              (prevTotal) => prevTotal - rowData[index]?.temp_new_payment
            );

            // setOpenConfirmModal(false);

            setPaymentDoneHeaders((prevState) => [
              ...prevState,
              {
                loan_header_id: index,
                rowData: { ...rowData[index] },
              },
            ]);
          }
        } else {
          setLoading(false);
        }
      } else {
        toast.warn("Entered Payment Must be Greater Than 0 !!!");
      }
    } else {
      toast.warn("Make Sure Fill Both Input Fields !!!");
    }
  };

  const handleCheckValues = (index) => {
    const rowValues = rowData[index];
    if (rowValues && rowValues.temp_new_payment) {
      setRowsWithValues((prevRows) => {
        const newRows = [...prevRows];
        newRows[index] = true;
        return newRows;
      });
    } else {
      setRowsWithValues((prevRows) => {
        const newRows = [...prevRows];
        newRows[index] = false;
        return newRows;
      });
    }
  };

  const handleRowDataChange = (newRowData, index) => {
    setRowData((prevState) => {
      const newState = [...prevState];
      newState[index] = newRowData;
      return newState;
    });
  };

  const handleDaysAbsentChange = (e, index) => {
    const { value } = e.target;
    setRowData((prevState) => {
      const newState = [...prevState];
      newState[index] = {
        ...newState[index],
        temp_days_absent: value,
      };
      return newState;
    });
  };

  const handleNewPaymentChange = (e, loanHeaderId, index) => {
    const { value } = e.target;
    console.log("value:::::::", value);

    setTotalPayments(
      (prevTotal) =>
        prevTotal -
        (rowData[loanHeaderId]?.temp_new_payment || 0) +
        (value ? parseFloat(value) : 0)
    );

    console.log("rowData length", rowData.length);
    // setCurrentIndex(index);

    setRowData((prevState) => {
      const newState = { ...prevState };
      newState[loanHeaderId] = {
        ...newState[loanHeaderId],
        temp_new_payment: value,
      };
      return newState;
    });
  };

  // useEffect(() => {}, [paymentDoneHeaders]);

  const processAllPaymentHandler = async () => {
    console.log("rowData before:::::::::", rowData);
    console.log("rowData111111111:::::::::", typeof rowData);
    if (rowData) {
      console.log("rowData:::::::::", rowData);
      setLoading(true);

      let processAllPayload = {
        rowData: rowData,
        token: userDataFromStorage.token,
      };

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };
      const { data } = await axios.post(
        `${API_HOST}/api/loan_header/process_all`,
        processAllPayload,
        config
      );
      if (data) {
        if (!data.message) {
          setLoading(false);
          toast.success("All Payments Added Successfully !!!");
          sessionStorage.setItem("user", JSON.stringify(data));
          navigate("/home");
        } else {
          setLoading(false);
          toast.error(data.message);
        }
      } else {
        setLoading(false);
      }
    } else {
      toast.warn("No Payments Entered !!!");
    }
  };

  const handleAgentNameChange = useCallback((e) => {
    setAgentLastName(e.target.value);
  }, []);

  const filteredAgentOptions = useMemo(() => {
    if (agentLastName && !selectedAgentName) {
      console.log("here");
      const searchTerm = agentLastName.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      agentNameList.forEach((option) => {
        if (
          option.agent_name &&
          option.agent_name.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.agent_name.toLowerCase().startsWith(searchTerm)",
            option.agent_name.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.agent_name.localeCompare(b.agent_name, undefined, {
          sensitivity: "base",
        })
      );

      console.log(
        "optionsStartingWithSearchTerm",
        optionsStartingWithSearchTerm
      );

      // setAgentLastName("");

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here agent");
      if (selectedAgentName) {
        console.log("here agent1111");
        setAgentNameForApi(selectedAgentName);
        setSelectedAgentName("");

        searchFilterOptionsShow.current = false;
      } else {
        console.log("here agent222");
        searchFilterOptionsShow.current = true;
      }

      return [];
    }
  }, [agentLastName, selectedAgentName]);

  useEffect(() => {
    if (processAllClicked) {
      processAllPaymentHandler();
    }
  }, [processAllClicked]);

  // useEffect(() => {
  //   if (filterData.length) {
  //     const wrapper = document.getElementById("tableWrapper");
  //     const child = document.getElementById("mainTable");

  //     console.log("child.clientHeight + px", child.clientHeight);
  //     console.log("wrapper.style.height", wrapper.style.height);

  //     // wrapper.style.height = child.clientHeight + "px";
  //     // Assuming you have a table with an id "myTable"
  //     const table = document.getElementById("mainTable");

  //     // Assuming you have <thead> and <tbody> elements inside the table
  //     const thead = table.querySelector("thead");
  //     const tbody = table.querySelector("tbody");

  //     // Calculate the total height of thead
  //     const theadHeight = thead.offsetHeight;

  //     // Calculate the height from the first row to the last row of tbody
  //     const firstRow = tbody.querySelector("tr");
  //     const lastRow = tbody.querySelector("tr:last-child");
  //     const tbodyHeight =
  //       lastRow.offsetTop + lastRow.offsetHeight - firstRow.offsetTop;

  //     console.log("Total height of thead:", theadHeight, "pixels");
  //     console.log(
  //       "Height from the first row to the last row of tbody:",
  //       tbodyHeight,
  //       "pixels"
  //     );

  //     wrapper.style.height = theadHeight + tbodyHeight + "px";
  //   }
  // }, [filterData]);

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden"
      }>
      <p className="text-gray-800 md:text-[1.8rem] text-[1rem] tracking-wider">
        Payments to be Collected Today
      </p>

      {/* search field */}
      <div className="bg-white pb-[1rem]">
        <p
          style={{ backgroundColor: coloredTheme }}
          className=" text-white px-[0.5rem] py-[1rem] mt-6">
          Search Fields
        </p>
        <div className="px-[0.5rem]">
          {userDataFromStorage.user_role === "admin" ||
          userDataFromStorage.user_role === "manager" ? (
            <div className="relative md:flex justify-start items-center mt-6">
              <p className="w-[30%]">Agent Last Name</p>
              <input
                type="text"
                value={agentLastName}
                placeholder="Enter Agent Last Name"
                onInput={(e) => {
                  console.log("e.target::::::", e.target.value);
                  handleAgentNameChange(e);
                }}
                className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
              />
              {filteredAgentOptions.length > 0 && (
                <div
                  className={
                    searchFilterOptionsShow.current === true
                      ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                      : "hidden"
                  }>
                  {filteredAgentOptions.map((option, index) => (
                    <div
                      className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                      onClick={() => {
                        console.log("option.agent_name::", option.agent_name);
                        setAgentLastName(option.agent_name);
                        setSelectedAgentName(option.agent_name);
                      }}
                      key={index}>
                      {option.agent_name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            ""
          )}
          <div className="md:flex justify-start items-center mt-6">
            <p className="w-[25rem]">Last Transaction was Today</p>
            <div className="mt-2 md:mt-0">
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={lastTransaction}
                  name="radio-buttons-group"
                  onChange={(e) =>
                    setLastTransaction(e.target.value === "true")
                  }
                  row>
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
          <div className="md:flex justify-start items-center mt-6">
            <p className="w-[25rem]">Next Payment is due Today or Earlier</p>
            <div className="mt-2 md:mt-0">
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={nextPaymentDue}
                  name="radio-buttons-group"
                  onChange={(e) => setNextPaymentDue(e.target.value === "true")}
                  row>
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
          <div className="md:flex justify-start items-center mt-6">
            <p className="w-[25rem]">
              Next Required Payment is due Today or Earlier
            </p>
            <div className="mt-2 md:mt-0">
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={nextRequiredPayment}
                  name="radio-buttons-group"
                  onChange={(e) =>
                    setNextRequiredPayment(e.target.value === "true")
                  }
                  row>
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
          <div className="flex items-center justify-start space-x-4 mt-6 ">
            <button
              onClick={() => {
                setAgentLastName("");
                setNextPaymentDue("");
                setNextRequiredPayment("");
                setLastTransaction("");
                setAgentNameForApi("");
              }}
              style={{ backgroundColor: coloredTheme }}
              className="flex items-center justify-start space-x-2  px-[1rem] py-[0.5rem] rounded text-white">
              <FaUndo />
              <p>Reset Search Fields</p>
            </button>
            <button
              onClick={() => getStartOfDay()}
              style={{ backgroundColor: coloredTheme }}
              className="flex items-center justify-start space-x-2  px-[1rem] py-[0.5rem] rounded text-white">
              <FiSearch />
              <p>Search</p>
            </button>
          </div>
        </div>
      </div>

      {/* table */}
      <div className="mt-8 w-[100%]">
        <p className="text-gray-800 md:text-[1.8rem] text-[1.3rem] tracking-wider">
          Collections
        </p>

        <div
          id="tableWrapper"
          className=" overflow-scroll h-[600px] md:h-auto  mt-[1rem] w-[100%]">
          <table
            id="mainTable"
            className="md:w-[100%] xl:w-[100%]  mt-6 md:scale-[100%] w-[300%] scale-[0.33] origin-top-left mr-[-1000%] md:mr-0">
            <thead className="h-[5vh]">
              <tr
                style={{ backgroundColor: coloredTheme }}
                className="border border-gray-700  text-white tracking-wider">
                {userDataFromStorage.user_role === "admin" && (
                  <th className="text-center text-[0.8rem] md:text-[1rem]  px-[0.2rem] border-b border-r   border-gray-700 ">
                    Manager
                  </th>
                )}
                {userDataFromStorage.user_role === "admin" ||
                userDataFromStorage.user_role === "manager" ? (
                  <th className="text-center text-[0.8rem] md:text-[1rem]  px-[0.2rem] border-b border-r   border-gray-700 ">
                    Agent
                  </th>
                ) : (
                  ""
                )}
                <th className="text-center text-[0.8rem] md:text-[1rem]  px-[0.2rem] border-b border-r   border-gray-700 ">
                  Customer Nickname
                </th>
                <th className="text-center text-[0.8rem] md:text-[1rem]  px-[0.2rem] border-b border-r   border-gray-700 ">
                  Product Code
                </th>
                <th className="text-center text-[0.8rem] md:text-[1rem]  px-[0.2rem] border-b border-r   border-gray-700 ">
                  Last Transaction
                </th>
                <th className="text-center text-[0.8rem] md:text-[1rem]  px-[0.2rem] border-b border-r   border-gray-700 ">
                  Amount Left
                </th>
                {/* <th className='text-center text-[0.8rem] md:text-[1rem]  px-[0.2rem] border-b border-r   border-gray-700 '>Next Payment Due</th> */}
                {/* <th className='text-center text-[0.8rem] md:text-[1rem]  px-[0.2rem] border-b border-r   border-gray-700 '>Payments ahead/behind</th> */}
                <th className="text-center text-[0.8rem] md:text-[1rem]  px-[0.2rem] border-b border-r   border-gray-700 ">
                  New Payment
                </th>
                {/* <th className='text-center text-[0.8rem] md:text-[1rem]  px-[0.2rem] border-b border-r   border-gray-700 '>Days Absent</th> */}
                <th className="text-center text-[0.8rem] md:text-[1rem]  px-[0.2rem] border-b border-r   border-gray-700 "></th>
                {userDataFromStorage.user_role === "admin" ||
                userDataFromStorage.user_role === "manager" ? (
                  <th className="text-center text-[0.8rem] md:text-[1rem]  px-[0.2rem] border-b border-r   border-gray-700 "></th>
                ) : (
                  ""
                )}
              </tr>
            </thead>
            <tbody>
              {filterData.length
                ? filterData.map((x, index) => {
                    let date = new Date(x?.last_transaction);
                    let day = String(date?.getUTCDate()).padStart(2, "0");
                    let month = String(date?.getUTCMonth() + 1).padStart(
                      2,
                      "0"
                    );
                    let year = String(date?.getUTCFullYear());
                    let modifiedLastTransactionDate = `${day}-${month}-${year}`;

                    let date1 = new Date(x?.next_payment_date);
                    let day1 = String(date1?.getUTCDate()).padStart(2, "0");
                    let month1 = String(date1?.getUTCMonth() + 1).padStart(
                      2,
                      "0"
                    );
                    let year1 = String(date1?.getUTCFullYear());
                    let modifiedLastTransactionDate1 = `${day1}-${month1}-${year1}`;

                    return (
                      <tr
                        // rowData={rowData && rowData[x.loan_header_id]}
                        // handlerowdatachange={(field, value) =>
                        //   handleRowDataChange(x.loan_header_id, field, value)
                        // }
                        className={
                          index % 2 === 0
                            ? "bg-white border border-gray-700 "
                            : "border border-gray-700 bg-sky-100"
                        }
                        key={index}
                        data-row={index}>
                        {userDataFromStorage.user_role === "admin" && (
                          <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                            {x.manager_name}
                          </td>
                        )}
                        {userDataFromStorage.user_role === "admin" ||
                        userDataFromStorage.user_role === "manager" ? (
                          <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                            {x.agent_name}
                          </td>
                        ) : (
                          ""
                        )}
                        <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                          {x.customer_nickname}
                        </td>
                        <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                          {x.product_code}
                        </td>
                        <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                          {modifiedLastTransactionDate}
                        </td>
                        <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                          {x.amount_left}
                        </td>
                        {/* <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>{modifiedLastTransactionDate1}</td> */}
                        {/* <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>{x.paymentsAhead}</td> */}
                        <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                          {new Date(x.last_transaction).toDateString() ===
                          new Date().toDateString() ? (
                            <p>{x.temp_new_payment}</p>
                          ) : paymentDoneHeaders.some(
                              (payment) =>
                                payment.loan_header_id === x.loan_header_id &&
                                payment.rowData.temp_new_payment
                            ) ? (
                            paymentDoneHeaders.map(
                              (payment) =>
                                payment.loan_header_id === x.loan_header_id && (
                                  <p>{payment.rowData.temp_new_payment}</p>
                                )
                            )
                          ) : (
                            <input
                              type="number"
                              onChange={(e) => {
                                setLoanHeaderCheck(x.loan_header_id);
                                setCurrentIndex(x.loan_header_id);
                                handleNewPaymentChange(
                                  e,
                                  x.loan_header_id,
                                  index
                                );
                                handleCheckValues(x.loan_header_id);
                              }}
                              value={
                                rowData[x.loan_header_id]?.temp_new_payment ||
                                ""
                              }
                              name="temp_new_payment"
                              className="border outline-none w-[8rem] px-[0.5rem]"
                              data-row={index}
                            />
                          )}
                        </td>
                        {/* <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>
                      <input
                        onChange={(e) => {
                          handleDaysAbsentChange(e, index);
                          handleCheckValues(index);
                          console.log("here amount")
                        }}
                        value={rowData[index]?.temp_days_absent || ''}
                        type={"number"} name="temp_days_absent" className="border outline-none w-[8rem] px-[0.5rem]" data-row={index} />
                    </td> */}

                        {new Date(x.last_transaction).toDateString() ===
                        new Date().toDateString() ? (
                          <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem] h-[3rem]">
                            <p>Payment Done !!!</p>
                          </td>
                        ) : rowData[x.loan_header_id] ? (
                          <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem] h-[3rem]">
                            {userDataFromStorage.process_all === true ? (
                              ""
                            ) : (
                              <button
                                onClick={() => {
                                  setCurrentIndex(x.loan_header_id);
                                  // handleAddStartOfDayCall(x.loan_header_id);
                                  // setOpenConfirmModal(true);
                                }}
                                style={{ backgroundColor: coloredTheme }}
                                className="flex justify-center items-center space-x-2  text-white rounded p-[0.5rem]">
                                <HiBadgeCheck className="text-[1rem] hidden md:block" />
                                {enterNewPaymentLoading &&
                                currentIndex === x.loan_header_id ? (
                                  <p className="text-white animate-pulse transition duration-[0.3s]">
                                    Processing . . .
                                  </p>
                                ) : (
                                  <p>Enter Payment</p>
                                )}
                              </button>
                            )}
                          </td>
                        ) : (
                          <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem] h-[3rem]">
                            {paymentDoneHeaders.some(
                              (payment) =>
                                payment.loan_header_id === x.loan_header_id &&
                                payment.rowData.temp_new_payment
                            ) ? (
                              <p>Payment Done !!!</p>
                            ) : (
                              <p>Enter Payment to be Collected !!!</p>
                            )}
                          </td>
                        )}

                        {userDataFromStorage.user_role === "admin" ||
                        userDataFromStorage.user_role === "manager" ? (
                          <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                            <button
                              style={{ backgroundColor: coloredTheme }}
                              className="flex justify-center items-center space-x-2  text-white rounded p-[0.5rem]">
                              <AiFillCloseCircle className="hidden md:block" />
                              <p>Close Loan</p>
                            </button>
                          </td>
                        ) : (
                          ""
                        )}
                      </tr>
                    );
                  })
                : ""}
            </tbody>
          </table>
        </div>

        {/* <div className="flex justify-end space-x-4 items-center mt-4  h-[50%]">
          <button
            className=" px-6 py-2 rounded-lg text-white bg-gray-400 hover:bg-gray-200 shadow-xl hover:text-gray-600 transition duration-[0.5s] tracking-wider"
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}>
            Prev
          </button>
          <button
            className=" px-6 py-2 rounded-lg text-white bg-gray-400 hover:bg-gray-200 shadow-xl hover:text-gray-600 transition duration-[0.5s] tracking-wider"
            onClick={() => setCurrentPage(currentPage + 1)}>
            Next
          </button>
        </div> */}

        <div
          style={{ backgroundColor: coloredTheme }}
          className=" w-[350%] py-[1rem] md:w-[180%] px-[0.5rem] text-white mt-6 xl:w-[100%] lg:w-[120%]">
          <p>
            {" "}
            Total New Payments Entered - MYR{" "}
            {currentTempNewPayments
              ? parseInt(currentTempNewPayments) + parseInt(totalPayments)
              : totalPayments
              ? parseInt(totalPayments)
              : 0}
          </p>
        </div>

        <div className="mt-8 flex items-center justify-start space-x-4 ">
          {userDataFromStorage.process_all === true ? (
            ""
          ) : (
            <button
              onClick={() => setProcessAllClicked(true)}
              style={{ backgroundColor: coloredTheme }}
              className="flex items-center justify-start space-x-2  px-[1rem] py-[0.5rem] rounded text-white">
              <AiFillLike />
              {processAllClicked ? "" : <p>Process All Payments</p>}
            </button>
          )}
          <button
            onClick={() => navigate("/home")}
            style={{ backgroundColor: coloredTheme }}
            className="flex items-center justify-start space-x-2  px-[1rem] py-[0.5rem] rounded text-white">
            <IoExitOutline />
            <p>Exit</p>
          </button>
        </div>
      </div>

      {/* <Modal
        open={openConfirmModal}
        onClose={() => setOpenConfirmModal(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="2xl:w-[40%] xl:w-[35%] lg:w-[50%] md:w-[50%] w-[80%] rounded-lg bg-white absolute top-[10%]  mb-[10rem] ">
          <div className="p-[0.8rem]">
            <p className="text-lg text-gray-800">Confirm Provided fields</p>
          </div>
          <Divider />
          <div className="p-[1rem]">
            <p className="text-[1.2rem] tracking-wider text-gray-800 text-center font-[600]">
              Are You Sure , You Want To Enter The Provided Next Payment ?
            </p>
            <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
              <button
                onClick={() => {
                  setOpenConfirmModal(false);
                }}
                className="flex justify-center items-center space-x-2 bg-purple-400 text-purple-50 px-[1rem] py-[0.5rem] rounded hover:text-purple-500 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
                <TbArrowBackUp />
                <p>Cancel</p>
              </button>
              <button
                onClick={() => handleAddStartOfDayCall()}
                className="flex justify-center items-center space-x-2 bg-green-400 text-green-50 px-[1rem] py-[0.5rem] rounded hover:text-green-500 hover:bg-green-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black ">
                <RiSave2Fill />
                <p>Proceed</p>
              </button>
            </div>
          </div>
        </Box>
      </Modal> */}

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default StartofDay;
